import { closeOpenStores, createOpenStore } from "stores/createOpenStore";
import type { StoredDescriptor } from "@/lib/api/attachments";

export interface AttachmentViewerOpen {
  tableId: string;
  /** The row's stored files; `index` points into this list, never the cell's. */
  files: StoredDescriptor[];
  index: number;
  /** Takes focus back on close while it is still in the document. */
  opener?: HTMLElement;
}

export const useAttachmentViewerStore = createOpenStore<AttachmentViewerOpen>();

/** The details pane's overlays sit above the canvas's stacking context, so one
 *  left open would cover the card: opening closes every open overlay first. */
export const openAttachmentViewer = (open: AttachmentViewerOpen): void => {
  closeOpenStores();
  useAttachmentViewerStore.getState().show(open);
};
